export const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: false,
  // time before error callback if no data acquired
  timeout: 100 * 1000, // 100 seconds
  // duration to keep position data cached, 5 minutes here
  maximumAge: 1000 * 60 * 5,
}
